import React from "react";
import UseCases from "../components/UseCases";
import MarketPlaceLayout from "../components/Layout/MarketPlaceLayout";


function UseCasesPage() {
  return (
    <MarketPlaceLayout>
          <UseCases />
    </MarketPlaceLayout>
  );
}

export default UseCasesPage;
